export const shadowXs = '0 0 0 1px rgba(0, 0, 0, 0.05)';
export const shadowSm = '0 1px 2px 0 rgba(0, 0, 0, 0.05)';
export const shadowM = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';
export const shadowMd = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
export const shadowLg = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
export const shadowXl = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
export const shadowInner = 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)';
export const shadowOutline = '0 0 0 3px rgba(66, 153, 225, 0.5)';
export const shadowHeavy = '3px 3px 16px rgba(0, 0, 0, 0.16)';
